<template>
  <div class="line contPadding">
    <div class="main-title">菜单管理</div>
    <el-row class="content-container">
      <el-col :span="7">
        <div class="selectList">
          <div class="title"><span></span>资源树：</div>
          <div class="custom-tree-container">
            <el-tree
              :data="dataTree"
              :props="defaultProps"
              @node-click="handleNodeClick"
            ></el-tree>
          </div>
        </div>
      </el-col>
      <el-col :span="17" v-show="show">
        <el-button type="primary" class="changeBtn" @click="addClick"
          >添加</el-button
        >
        <el-table :data="tableData" style="width: 100%">
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column
            prop="resourceName"
            label="资源名称"
          ></el-table-column>
          <el-table-column prop="resourceType" label="资源类型">
            <template slot-scope="scope">
              <span>{{
                scope.row.resourceType === '1' ? '菜单' : '目录'
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope" fixed="right">
              <el-button
                type="text"
                style="font-size: 12px"
                @click="handleEdit(scope.row)"
                >修改</el-button
              >
              <el-button
                type="text"
                style="font-size: 12px"
                @click="handleDelete(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="total"
          class="pagination"
        ></el-pagination>
      </el-col>
    </el-row>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="850px">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="资源名称" prop="resourceName">
              <el-input v-model="ruleForm.resourceName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="打开方式">
              <el-select v-model="ruleForm.showType" placeholder="默认">
                <el-option label="默认" value="DEFAULT"></el-option>
                <el-option label="弹出" value="POPUP"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="资源类型" prop="resourceType">
              <el-radio-group v-model="ruleForm.resourceType">
                <el-radio label="目录"></el-radio>
                <el-radio label="菜单"></el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="目录图标">
              <el-input v-model="ruleForm.icon"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="上级资源">
              <el-input
                v-model="ruleForm.parentName"
                :disabled="disabled"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="资源路径" prop="resourceUrl">
              <el-input v-model="ruleForm.resourceUrl"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="排序">
              <el-input v-model="ruleForm.resourceSortnum"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('ruleForm')"
          >确 定</el-button
        >
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
let addBool, updateBool;
export default {
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      props: {
        label: 'name',
        children: 'zones',
        isLeaf: 'leaf'
      },
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      dataTree: [],
      tableData: [],
      loading: true,
      parentId: '',
      ruleForm: {
        resourceName: '',
        showType: 'DEFAULT',
        resourceType: '',
        parentName: '',
        resourceUrl: '',
        resourceSortnum: '',
        id: '',
        parentId: '',
        icon: ''
      },
      rules: {
        resourceName: [
          { required: true, message: '请输入资源名称', trigger: 'blur' }
        ],
        resourceUrl: [
          { required: true, message: '请输入资源路径', trigger: 'blur' }
        ],
        resourceType: [
          { required: true, message: '请选择资源类型', trigger: 'blur' }
        ]
      },
      dialogVisible: false,
      show: false,
      parent: '',
      id: '',
      disabled: true,
      method: '',
      dialogTitle: '添加菜单'
    };
  },
  created() {
    this.loadMenu();
  },
  methods: {
    handleSizeChange(val) {
      this.tableData = [];
      this.currentPage = 1;
      this.pageSize = val;
      this.tableData = [];
      this.loadMenuByClause();
    },
    handleCurrentChange(val) {
      this.tableData = [];
      this.currentPage = val;
      this.tableData = [];
      this.loadMenuByClause();
    },
    // 资源树
    loadMenu() {
      this.$request({
        url: 'rest/bsp/pubMenu/loadMenu'
      }).then(res => {
        this.dataTree = res;
      });
    },
    // 查看树每条数据
    handleNodeClick(data) {
      this.ruleForm.parentName = data.label;
      this.show = true;
      this.tableData = [];
      this.parent = data.id;
      this.id = data.id;
      this.loadMenuByClause();
    },
    // 表格详情
    loadMenuByClause() {
      this.tableData = [];
      this.$request({
        url: 'rest/bsp/pubMenu/loadMenuByClause',
        data: {
          parentId: this.id,
          pageNum: this.currentPage,
          pageSize: this.pageSize
        }
      }).then(res => {
        this.total = res.total;
        res.list.forEach(item => {
          const tableItem = {
            icon: item.icon, // 图标地址
            parentId: item.parentId, // 父节点id
            // parentName: item.parentName,
            resourceName: item.resourceName, // 资源名称
            resourceSortnum: item.resourceSortnum, // 排序
            resourceType: item.resourceType, // 资源类型
            id: item.id,
            resourceUrl: item.resourceUrl, // 资源路径
            showType: item.userRealname // 打开方式
          };
          this.tableData.push(tableItem);
        });
      });
    },
    // form表单详情
    loadMenuById(row) {
      this.$request({
        url: 'rest/bsp/pubMenu/loadMenuById',
        data: {
          id: row.id
        }
      }).then(res => {
        if (res.resourceType === '0') {
          this.ruleForm.resourceType = '目录'; // 0 目录  1 菜单
        } else {
          this.ruleForm.resourceType = '菜单';
        }
        this.ruleForm.icon = res.icon;
        this.ruleForm.showType = res.showType;
        this.ruleForm.resourceName = res.resourceName; // 资源名称
        this.ruleForm.resourceSortnum = res.resourceSortnum; // 排序
        this.ruleForm.resourceUrl = res.resourceUrl; // 路径
        this.ruleForm.parentName = res.parentName;
        this.ruleForm.id = res.id;
        this.ruleForm.parentId = res.parentId;
      });
    },
    // 新增按钮
    addClick() {
      this.dialogTitle = '添加菜单';
      this.dialogVisible = true;
      this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
      addBool = true;
      updateBool = false;
      this.method = 'add';
    },
    // 修改
    handleEdit(row) {
      this.dialogTitle = '修改菜单';
      this.dialogVisible = true;
      updateBool = true;
      addBool = false;
      this.method = 'update';
      this.loadMenuById(row);
    },
    // 新增-添加
    add() {
      this.$request({
        url: 'rest/bsp/pubMenu/mergeMenu',
        data: {
          method: this.method,
          parentId: this.parent,
          resourceName: this.ruleForm.resourceName,
          resourceSortnum: this.ruleForm.resourceSortnum,
          resourceUrl: this.ruleForm.resourceUrl,
          showType: this.ruleForm.showType,
          resourceType: this.ruleForm.resourceType === '菜单' ? '1' : '0',
          icon: this.ruleForm.icon
        }
      }).then(res => {
        this.$message({
          message: '恭喜你，添加成功',
          type: 'success'
        });
        this.loadMenuByClause();
        this.loadMenu();
        this.dialogVisible = false;
      });
    },
    // 修改-提交
    update() {
      this.$request({
        url: 'rest/bsp/pubMenu/mergeMenu',
        data: {
          method: this.method,
          parentId: this.ruleForm.parentId,
          id: this.ruleForm.id,
          resourceName: this.ruleForm.resourceName,
          resourceSortnum: this.ruleForm.resourceSortnum,
          resourceUrl: this.ruleForm.resourceUrl,
          showType: this.ruleForm.showType,
          resourceType: this.ruleForm.resourceType === '菜单' ? '1' : '0',
          icon: this.ruleForm.icon
        }
      }).then(res => {
        this.$message({
          message: '恭喜你，修改成功',
          type: 'success'
        });
        this.loadMenuByClause();
        this.loadMenu();
        this.dialogVisible = false;
      });
    },
    // 表单提交（修改+新增）
    submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          if (addBool) {
            this.add();
            addBool = false;
          }
          if (updateBool) {
            this.update();
            updateBool = false;
          }
        } else {
          return false;
        }
      });
    },
    // 删除
    handleDelete(row) {
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$request({
          url: 'rest/bsp/pubMenu/deleteMenuById',
          data: {
            id: row.id
          }
        }).then(res => {
          this.$message({
            message: '删除成功',
            type: 'success'
          });
          this.loadMenuByClause();
          this.loadMenu();
        });
      });
    }
  }
};
</script>
<style>
/*.el-tree-node__content,
.el-tree-node__label {
  font-size: 12px !important;
}*/
.el-tree-node__expand-icon {
  font-size: 18px !important;
}
.el-form-item.is-success .el-input__inner,
.el-form-item.is-success .el-input__inner:focus,
.el-form-item.is-success .el-textarea__inner,
.el-form-item.is-success .el-textarea__inner:focus {
  border-color: #d9d9d9;
}
.el-input.is-disabled .el-input__inner {
  background: none !important;
  border-color: #e4e7ed;
  color: #5a5e66;
  cursor: not-allowed;
}
</style>

<style lang="stylus" scoped>
@import './common.styl'
.line
  i
    cursor pointer
    font-style normal
    font-weight normal
  .style
    background #39be6b
    border-radius 3px
    padding 2px 3px
    font-size 10px
    color #fff
    text-align center
  .Edit
    background #298cf1
  .Delete
    background #ee3c0c
  .selectList
    height 100vh
    margin-right 10px
    border-right 1px solid #d9e4f4
    background #fff
  .content
    background #fff
    height 100vh
    padding 10px 10px 0 10px
  .custom-tree-node
    flex 1
    display flex
    align-items center
    justify-content space-between
    font-size 12px !important
    padding-right 8px
    .el-button--text
      margin-left 20px
    span
      font-size 12px !important
.changeBtn
  margin 10px 0 10px 0
  float right
  cursor pointer
.back
  width 100%
  height 100%
  background rgba(0, 0, 0, 0.4)
  position fixed
  top 0
  left 0
  z-index 10
  .iconClose
    position absolute
    top 10px
    right 10px
    width 20px
    height 20px
    border-radius 100%
    border 1px solid
    text-align center
    line-height 20px
    cursor pointer
  .submitForm
    position absolute
    top 230px
    left 33%
    width 660px
    height 350px
    overflow-y auto
    background #fff
    padding 15px
  .el-form-item__label,
  .el-input,
  .el-date-editor .el-range-input,
  .el-table thead,
  .el-table__row
    width 180px !important
    font-size 14px !important
.pagination
  padding 20px
  background #fff
  text-align right
</style>
